import { selectedCustomerIdSelector } from '@src/store/common/selectors';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { useAllowedMonths } from '../../hooks/shared/useAllowedMonths';

export const useAllowedTimeRangeMoment = () => {
  const endTimeMoment = moment();
  const selectedCustomerId = useSelector(selectedCustomerIdSelector);
  const value = useAllowedMonths(selectedCustomerId);

  // Old data model - past 1 month
  // TODO: need to open this ff check when timeline data limited to 7 days
  // New data model - past 7 days
  const startTimeMoment = moment().subtract(value, 'month').startOf('day');

  return {
    startTimeMoment,
    endTimeMoment,
  };
};
